import React, { useEffect, useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import Map, { Source, Layer, Marker, Popup, NavigationControl } from "react-map-gl";
import { es } from "date-fns/locale/es";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import axios from "axios";
import "mapbox-gl/dist/mapbox-gl.css";
import { URL_BASE } from "../../config/url-server";
import farmService from "../../services/farm-service";
import sectionService from "../../services/section-service";
import lotService from "../../services/lot-service";
import DatePicker from "react-datepicker";
import { Divider, Spin } from "antd";
import moment from "moment";
import config from "../../config/config";
import { ToastContainer, toast } from 'react-toastify';
const PolygonHectareLot = () => {

    const color_0 = "#FFFFFF";       // amarillo muy claro
    const color_1_50 = "#FFF59D";   // amarillo claro
    const color_50_100 = "#FFEB3B";  // amarillo
    const color_100_150 = "#FFB300"; // amarillo/naranja
    const color_150_200 = "#F4511E"; // naranja/rojo
    const color_200 = "#D32F2F";     // rojo


    const [loading, setLoading] = useState(false);
    registerLocale("es", es);

    registerLocale("es", es);

    const start_date = moment().subtract(1, 'month').startOf('month').toDate();
    const end_date = moment().subtract(1, 'month').endOf('month').toDate();
    const [startDate, setStartDate] = useState(start_date);
    const [endDate, setEndDate] = useState(end_date);


    const [sectionId, setSectionId] = useState("0");
    const escoja = [{ _id: 0, name: "-ESCOJA-" }];
    const [listSection, setListSection] = useState(escoja);
    const [listFarms, setListFarms] = useState(escoja);
    const [listLots, setListLots] = useState(escoja);

    ///Aplicaciones por dia
    const [lotId, setLotId] = useState("0");
    const [farmId, setFarmId] = useState("0");

    const clientId = localStorage.getItem("client")
    const accessToken = localStorage.getItem("token")
    const [lotPolygons, setLotPolygons] = useState([]);
    const [selectedLot, setSelectedLot] = useState(null);
    const [selectedLotPosition, setSelectedLotPosition] = useState(null);

    //5.391078, -73.869958
    const [viewState, setViewState] = useState({
        latitude: 5.391078, // Se actualizará dinámicamente
        longitude: -73.869958, // Se actualizará dinámicamente
        zoom: 5, // Zoom inicial
    });


    // ===== PALETA DE COLORES VIBRANTES (fuera del componente) =====
    const VIBRANT_COLORS = [
        "#E41A1C", // Rojo
        "#377EB8", // Azul
        "#4DAF4A", // Verde
        "#984EA3", // Púrpura
        "#FF7F00", // Naranja
        "#FFFF33", // Amarillo
        "#A65628", // Marrón
        "#F781BF", // Rosa
        "#999999", // Gris
        "#66C2A5", // Verde azulado
        "#FC8D62", // Naranja claro
        "#8DA0CB", // Azul claro
        "#E78AC3", // Rosa claro
        "#A6D854", // Verde lima
        "#FFD92F", // Amarillo claro
    ];



    const getApplicationColor = (value) => {
        const applications = Number(value ?? 0);


        if (applications <=1) return color_0;
        if (applications <= 50) return color_1_50;
        if (applications <= 100) return color_50_100;
        if (applications <= 150) return color_100_150;
        if (applications <= 200) return color_150_200;

        return color_200;
    };

    const lotPolygonsGeoJson = useMemo(() => {

        return {
            type: "FeatureCollection",

            features: lotPolygons
                .filter(lot =>
                    lot.lotPolygon?.type === "Polygon" &&
                    lot.lotPolygon?.coordinates?.length > 0
                )
                .map((lot, index) => {

                    return {
                        type: "Feature",

                        geometry: {
                            type: "Polygon",
                            coordinates: lot.lotPolygon.coordinates
                        },

                        properties: {
                            id: lot._id,
                            name: lot.name,
                            lotCode: lot.lotCode,

                            totalApplicationsType1:
                                lot.totalApplicationsType1 ?? 0,

                            palmsVisited:
                                lot.palmsVisited ?? 0,

                            hectaresVisited: Math.round(lot.hectaresVisited ?? 0),

                            averageByHectare: Math.round(lot.averageByHectare ?? 0),

                            hectares:
                                lot.hectares ?? 0,

                            palmsPlanted:
                                lot.palmsPlanted ?? 0,

                            density:
                                lot.density ?? 0,

                            color: getApplicationColor(lot.averageByHectare)
                        }
                    };
                })
        };

    }, [lotPolygons]);


    const lotPolygonsLayer = lotPolygons.length > 0 ? (
        <Source
            id="lot-polygons"
            type="geojson"
            data={lotPolygonsGeoJson}
        >
            <Layer
                id="lot-polygons-fill"
                type="fill"
                paint={{
                    "fill-color": ["get", "color"],
                    "fill-opacity": 0.8
                }}
            />

            <Layer
                id="lot-polygons-line"
                type="line"
                paint={{
                    "line-color": ["get", "color"],
                    "line-width": 2,
                    "line-opacity": 0.9,
                    "line-dasharray": [3, 2]
                }}
            />

            <Layer
                id="lot-polygons-label"
                type="symbol"
                layout={{
                    "text-field": [
                        "format",

                        ["get", "name"],
                        {
                            "font-scale": 1.1
                        },

                        "\n",
                        {},

                        [
                            "concat",
                            "",
                            ["to-string", ["get", "averageByHectare"]],
                            "/ha"
                        ],
                        {}
                    ],
                    "text-size": 12,
                    "text-allow-overlap": true
                }}
                paint={{
                    "text-color": "#FFFFFF",
                    "text-halo-color": "#000000",
                    "text-halo-width": 2
                }}
            />
        </Source>
    ) : null;



    const {
        register,
        getValues,
        setValue,
        formState: { errors },
    } = useForm();


    const getLisFarm = async () => {
        if (farmId == "0") {
            let listado = await farmService.getList();
            if (listado) {
                listado.push({ _id: 0, name: "-ESCOJA-" });
                const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
                setListFarms(sortedItems);
            }
        }
    };

    const getListSection = async (e) => {
        const code = e.target.value;
        if (code == "0") {
            setListSection(escoja);
            setListLots(escoja);
            setValue("section", "0")
            setValue("lot", "0")
            setValue("user", "0")
            setFarmId(code);
            return;
        }
        let listado = await sectionService.getListByFarm(code);
        listado.push({ _id: 0, name: "-ESCOJA-" });
        if (listado) {
            const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
            setListSection(sortedItems);
            setValue("section", "0")
            setValue("lot", "0")
            setValue("user", "0")
        }

        setFarmId(code);
    };

    const getLisLots = async (e) => {
        const code = e.target.value;
        setSectionId(code)
        if (code == "0") {
            setListLots(escoja);
            setValue("lot", "0")
            setValue("user", "0")
            return;
        }
        let listado = await lotService.getListBySection(code);
        listado.push({ _id: 0, name: "-ESCOJA-" });
        if (listado) {
            const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
            setListLots(sortedItems);
            setValue("lot", "0")
            setValue("user", "0")
        }
    };



    const isValidCoordinate = (coord) => {
        return (
            Array.isArray(coord) &&
            coord.length === 2 &&
            !isNaN(parseFloat(coord[0])) &&
            !isNaN(parseFloat(coord[1]))
        );
    };





    const loadPolygonMap = async () => {
        const sectionId = getValues("section");



        try {
            const farmId = getValues("farm")
            const lotId = getValues("lot")
            const sectionId = getValues("section")
            const user = getValues("user")
            const option = getValues("option")
            let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
            let end = moment(endDate).endOf("day").format('YYYY-MM-DD');

            const params = { farmId, sectionId, lotId, startDate: start, endDate: end, userId: user, option }
            const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` }, params };
            setLoading(true)



            const response = await axios.get(URL_BASE + "map/polygon-hectare-lot", config);



            const polygons = response?.data?.data || [];
            setLotPolygons(polygons);

            setLoading(false);


            //aca vendria lo nuevo
        } catch (error) {
            console.error("Error obteniendo los datos:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        getLisFarm();
    }, []);


    useEffect(() => {

        if (!lotPolygonsGeoJson?.features?.length) {
            return;
        }

        const coordinates = [];

        lotPolygonsGeoJson.features.forEach(feature => {

            const rings = feature.geometry.coordinates;

            rings.forEach(ring => {

                ring.forEach(([lng, lat]) => {

                    coordinates.push([lng, lat]);

                });

            });

        });

        if (coordinates.length === 0) {
            return;
        }

        let minLng = coordinates[0][0];
        let maxLng = coordinates[0][0];
        let minLat = coordinates[0][1];
        let maxLat = coordinates[0][1];

        coordinates.forEach(([lng, lat]) => {

            minLng = Math.min(minLng, lng);
            maxLng = Math.max(maxLng, lng);

            minLat = Math.min(minLat, lat);
            maxLat = Math.max(maxLat, lat);

        });

        const centerLng = (minLng + maxLng) / 2;
        const centerLat = (minLat + maxLat) / 2;

        setViewState(prev => ({
            ...prev,
            longitude: centerLng,
            latitude: centerLat,
            zoom: 14
        }));

    }, [lotPolygonsGeoJson]);




    return (
        <div className="row">
            <ToastContainer />

            <div className="col-12 col-sm-2">
                <div className="col-12 ml-4 ms-2" style={{ marginTop: "-10px" }}>
                    <Divider orientation="left" style={{ border: "#AAAAAA" }} >Aplicaciones/ha</Divider>
                </div>

                <form className="form-react">
                    <div className="row ms-2">

                        <div className=" col-12">
                            <label className="text-secondary fw-bold">Finca</label>
                            <select
                                className="form-control text-secondary"
                                {...register("farm")}
                                onChange={(e) => getListSection(e)}
                            >
                                {listFarms.map((option) => (
                                    <option key={option._id} value={option._id}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="  col-12 col-sm-12">
                            <label className="text-secondary fw-bold">Sección</label>
                            <select
                                className="form-control text-secondary"
                                {...register("section")}
                                onChange={(e) => getLisLots(e)}
                            >
                                {listSection.map((option) => (
                                    <option key={option._id} value={option._id}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className=" col-12 d-none">
                            <label className="text-secondary fw-bold ">Lote</label>
                            <select
                                className="form-control text-secondary"
                                {...register("lot")}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setLotId(value);
                                }}
                            >
                                {listLots.map((option) => (
                                    <option key={option._id} value={option._id}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className=" col-12">
                            <label className="text-secondary fw-bold">Desde</label>
                            <br />
                            <DatePicker
                                {...register("startDate")}
                                locale="es"
                                dateFormat="yyyy-MM-dd"
                                className="form-control text-secondary"
                                selected={startDate}
                                onChange={(date) => {
                                    setStartDate(date)
                                }}
                            />
                        </div>

                        <div className=" col-12">
                            <label className="text-secondary fw-bold">Hasta</label>
                            <br />
                            <DatePicker
                                {...register("endDate")}
                                locale="es"
                                dateFormat="yyyy-MM-dd"
                                className="form-control text-secondary"
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                            />
                        </div>





                        <div className=" col-12">
                            <label className="text-secondary fw-bold">&nbsp;</label>
                            <br />
                            <Spin spinning={loading}>
                                <button
                                    className="btn btn-primary w-100"
                                    type="button"
                                    onClick={() => loadPolygonMap()}
                                >
                                    <i className="bi bi-search fa-lg m-2" /> Buscar
                                </button>
                            </Spin>
                        </div>

                    </div>
                </form>



                 <div className="col-12 m-3">

                        <h6 style={{ fontWeight: "bold", marginBottom: "8px" }}>Leyenda de colores</h6>
                        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: color_0, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>0 racimos</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: color_1_50, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>1 a 50 racimos</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: color_50_100, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>51 a 100 racimos</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: color_100_150, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>101 a 150 racimos</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: color_150_200, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>151 a 200 racimos</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: color_200, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>200 o más racimos</span>
                            </div>
                        </div>

                    </div>


            </div>

            <div className="col-12 col-sm-10">
                <Map
                    interactiveLayerIds={[
                        "lot-polygons-fill"
                    ]}

                    {...viewState}

                    onMove={evt => setViewState(evt.viewState)}

                    onClick={(event) => {

                        const feature = event.features?.[0];

                        if (!feature) {
                            setSelectedLot(null);
                            setSelectedLotPosition(null);
                            return;
                        }

                        if (feature.layer?.id === "lot-polygons-fill") {

                            const lotId = feature.properties.id;

                            const lot = lotPolygons.find(
                                item =>
                                    String(item._id) === String(lotId)
                            );

                            if (lot) {

                                setSelectedLot(lot);

                                setSelectedLotPosition({
                                    longitude: event.lngLat.lng,
                                    latitude: event.lngLat.lat
                                });
                            }
                        }
                    }}

                    style={{
                        width: "100%",
                        height: "100vh"
                    }}

                    mapStyle="mapbox://styles/mapbox/satellite-v9"
                    mapboxAccessToken="pk.eyJ1IjoianVhbmNwaW5lZGFtIiwiYSI6ImNtNXlyNmxtbjBubm0ya3B5ZHVnMWgwcWYifQ.dogzl3DX9PMO9QywZ8CbyA"
                >
                    <NavigationControl position="top-left" />

                    {/* POLÍGONOS */}
                    {lotPolygonsLayer}


                    {/* POPUP DEL LOTE */}
                    {selectedLot &&
                        selectedLotPosition && (

                            <Popup
                                longitude={selectedLotPosition.longitude}
                                latitude={selectedLotPosition.latitude}
                                anchor="bottom"
                                closeOnClick={false}
                                onClose={() => {
                                    setSelectedLot(null);
                                    setSelectedLotPosition(null);
                                }}
                            >

                                <div style={{
                                    minWidth: "220px"
                                }}>

                                    <div
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                            marginBottom: "8px"
                                        }}
                                    >
                                        {selectedLot.name}
                                    </div>

                                    <div>
                                        <strong>
                                            Aplicaciones:
                                        </strong>{" "}
                                        {Number(
                                            selectedLot.totalApplicationsType1 ?? 0
                                        ).toLocaleString("es-CO")}
                                    </div>

                                    <div>
                                        <strong>
                                            Aplicaciones/ha:
                                        </strong>{" "}
                                        {Number(
                                            selectedLot.averageByHectare ?? 0
                                        ).toFixed(1)}
                                    </div>

                                    <div>
                                        <strong>
                                            Ha recorridas:
                                        </strong>{" "}
                                        {Number(
                                            selectedLot.hectaresVisited ?? 0
                                        ).toFixed(2)}
                                    </div>

                                    <div>
                                        <strong>
                                            Palmas visitadas:
                                        </strong>{" "}
                                        {Number(
                                            selectedLot.palmsVisited ?? 0
                                        ).toLocaleString("es-CO")}
                                    </div>

                                    <hr />

                                    <div>
                                        <strong>
                                            Ha del lote:
                                        </strong>{" "}
                                        {Number(
                                            selectedLot.hectares ?? 0
                                        ).toFixed(2)}
                                    </div>

                                    <div>
                                        <strong>
                                            Palmas plantadas:
                                        </strong>{" "}
                                        {Number(
                                            selectedLot.palmsPlanted ?? 0
                                        ).toLocaleString("es-CO")}
                                    </div>

                                    <div>
                                        <strong>
                                            Densidad:
                                        </strong>{" "}
                                        {selectedLot.density ?? 0} palmas/ha
                                    </div>

                                </div>

                            </Popup>
                        )}

                </Map>
            </div>
        </div>
    );
};

export default PolygonHectareLot;